import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import NumberFormat from "react-number-format";
import AccountDropDown from "../../../../components/dropDown/account";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const AddPositionView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-7">
                        <TitlePage title="Prestatario \ Captura de Garantías \ Captura Posición"/>
                    </div>
                    <div className="p-col-5" align="right">
                        <Button label="Regresar" className="p-button-secondary"
                                onClick={props.returnCaptureGuaranteesPage}/>&nbsp;
                        <Button label="Guardar" onClick={props.savePosition}/>
                    </div>
                    <div className="p-col-12"><Divider/></div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Tipo Valor" isBold={true}/>
                        <InputText name="tipoValor" placeholder="Ex: ISM"
                                   required={true} maxLength={4}
                                   onChange={props.onChangeInputText}
                                   value={props.positionData.tipoValor}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Emisora" isBold={true}/>
                        <InputText name="emisora" placeholder="Ex: ALFA"
                                   required={true} maxLength={15}
                                   onChange={props.onChangeInputText}
                                   value={props.positionData.emisora}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Serie" isBold={true}/>
                        <InputText name="serie" placeholder="Ex: 201010"
                                   required={true} maxLength={10}
                                   onChange={props.onChangeInputText}
                                   value={props.positionData.serie}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-1">
                        <Button label="Validar" onClick={props.validateEmisora}/>
                    </div>
                    <div className="p-col-12"><Divider/></div>
                    <div className="p-col-12">
                        <SubtitleLabel header="Detalle de Emisora:" isBold={true}/>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Cupón" isBold={true}/>
                        <SubtitleLabel header= {props.positionData.cupon}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="ISIN" isBold={true}/>
                        <SubtitleLabel header={props.positionData.isin}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Precio" isBold={true}/>
                        <SubtitleLabel header={props.positionData.precio}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Fecha vencimiento" isBold={true}/>
                        <SubtitleLabel header={props.positionData.fechaVence}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Cuenta" isBold={true}/>
                        <AccountDropDown
                            name="cuenta"
                            filter="cuenta"
                            ref={props.accountDropDown}
                            save={props.onChangeAccount}
                            value={props.positionData.accountObject}
                            sessionAccount={true}
                            required={true}
                            loading={props.loading}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Títulos" isBold={true}/>
                        <NumberFormat thousandSeparator={true}
                                      maxLength={17}
                                      required={true}
                                      decimalScale={0}
                                      fixedDecimalScale={false}
                                      allowNegative={false}
                                      name="cantidadTitulos"
                                      placeholder="Ex: 9,999.00"
                                      customInput={InputText}
                                      onChange={props.onChangeInputText}
                                      value={props.positionData.cantidadTitulos}/>
                    </div>
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(AddPositionView);